export default {
  GET_KEYPAD_NEXT_BUTTON_TABLE_BUBBLE: (state) => {
    return state.keypadNextButtonTableBubble;
  },
  GET_CURRENT_CELL_INDEX: (state) => {
    return state.nextTableBubbleCellIndex;
  },
  GET_CURRENT_MEASURMENT_TABLE_CELL: (state) => {
    return state.currentMeasurmentTableCell;
  },
  GET_CURRENT_DISPLAY_UNIT: (state) => {
    return state.displayUnit;
  },
};
